export default "__VITE_ASSET__CiJt$V9j__"